module.exports = __webpack_public_path__ + "static/media/scotland.0e87d2cd.svg";